import IResetPassword from "../models/account/IResetPassword";
import { IUserListResponse } from "../models/account/IUserInfo";
import IUserProfile, {
    IUpdateUserProfile
} from "../models/account/IUserProfile";
import { apiSlice } from "./apiSlice";

const ROUTE = "/account";

export const accountApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserList: builder.query<IUserListResponse, void>({
            query: () => `${ROUTE}/get-user-list`
        }),
        getUserProfile: builder.query<IUserProfile, string>({
            query: (email) =>
                `${ROUTE}/get-user-profile?email=${encodeURIComponent(email)}`
        }),
        resetPasswordTokenCheck: builder.query<boolean, string>({
            query: (token) => `${ROUTE}/reset-password-token-check/${token}`
        }),
        resetPassword: builder.mutation<string, IResetPassword>({
            query: (resetPassword) => ({
                url: `${ROUTE}/reset-password`,
                method: "POST",
                body: resetPassword,
                responseHandler: (response) => {
                    if (response.ok) {
                        return response.text();
                    } else {
                        return response.json();
                    }
                }
            })
        }),
        updateUserProfile: builder.mutation<IUserProfile, IUpdateUserProfile>({
            query: (body) => ({
                url: `${ROUTE}/update-profile`,
                method: "PUT",
                body
            })
        }),
        resetTermsAcceptance: builder.mutation<void, void>({
            query: () => ({
                url: `${ROUTE}/reset-terms-acceptance`,
                method: "POST"
            })
        })
    })
});

export const {
    useGetUserListQuery,
    useGetUserProfileQuery,
    useLazyGetUserListQuery,
    useResetPasswordMutation,
    useResetPasswordTokenCheckQuery,
    useResetTermsAcceptanceMutation,
    useUpdateUserProfileMutation
} = accountApiSlice;
